import { render, staticRenderFns } from "./PageLoadingMask.vue?vue&type=template&id=24728d86&scoped=true&"
import script from "./PageLoadingMask.vue?vue&type=script&lang=js&"
export * from "./PageLoadingMask.vue?vue&type=script&lang=js&"
import style0 from "../../styles/page-loading-mask.css?vue&type=style&index=0&id=24728d86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24728d86",
  null
  
)

export default component.exports